import { OPEN_DRAWER, CLOSE_DRAWER } from "../../../constant/actionTypes";

export const handleDrawerToggle = (open) => {
  return (dispatch) => {
    if (open) {
      dispatch({
        type: OPEN_DRAWER,
      });
    } else {
      dispatch({
        type: CLOSE_DRAWER,
      });
    }
  };
};
